import { MollieInstance } from "@/components/Payment/types";
import { config } from "@/config/config";

let mollieInstance: MollieInstance|null = null;

export function getMollieInstance(): MollieInstance {
    if (!mollieInstance) {
        mollieInstance = window.Mollie(config.app.mollie.profileId!, { locale: "fr_FR", testmode: config.app.mollie.testmode });
    }
    return mollieInstance;
}

declare global {
    interface Window {
        Mollie: (profileId: string, options: { locale: string; testmode: boolean }) => MollieInstance;
    }
}